var _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#606060",
    cx: 9.8,
    cy: 4.5,
    r: 4.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    d: "M19.5,17.9c0,3.5-5.1,5.6-9.3,5.6S0,21.4,0,17.9s5.5-6.4,9.8-6.4S19.5,14.3,19.5,17.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    d: "M15,24H4.5C2,24,0,22,0,19.5v-1C0,16,2,14,4.5,14H15c2.5,0,4.5,2,4.5,4.5v1C19.5,22,17.5,24,15,24z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 19.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 17.2496 42.7993)",
    fill: "#FFFFFF",
    width: 3.2,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.9,
    y: 20.5,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 32.3713 13.497)",
    fill: "#FFFFFF",
    width: 3.1,
    height: 4.9
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "7,19.9 11.9,24.5 25,12.1 20.1,7.5  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M8.1,20.3v3.1h3.3l9.7-9.1l-3.3-3.1L8.1,20.3z M23.6,11.9c0.3-0.3,0.3-0.8,0-1.2l-2-1.9 c-0.3-0.3-0.9-0.3-1.2,0l-1.6,1.5l3.3,3.1C22,13.4,23.6,11.9,23.6,11.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPerson);
export default __webpack_public_path__ + "static/media/contactPerson.f85702c22a89b018551bba2985fa6de7.svg";
export { ForwardRef as ReactComponent };